// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { TouchCardKind } from "../../touchCard/common/data/TouchCardKind";
import ShopTouchCardSelectItem from "./ShopTouchCardSelectItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ShopTouchCardSelectLayer extends BasePopUpLayer {


	@property({ type: cc.Node, displayName:'' })
	nodeLayout: cc.Node = null;

    @property(cc.Prefab)
    prefabItem: cc.Prefab = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        O1HD.on(MessageEventKind.EventName.UPDATE_LOTTERY_LIST, this.updateLotteryList, this);
        this.initLayer();

    }

    initLayer() {
        this.nodeLayout.active = true;
        this.nodeLayout.removeAllChildren();

        let list = TouchCardKind.ItemList;
        for (let i = 0; i < list.length; i++) {
            let o = list[i];

            let nodeItem = cc.instantiate(this.prefabItem);
            this.nodeLayout.addChild(nodeItem);

            let script = nodeItem.getComponent(ShopTouchCardSelectItem);
            script.setData(o, this);
        }
    }

    updateLotteryList() {
        this.initLayer();
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    // update (dt) {}
}
 